package com.trevorwiebe.timesheet.mileage.domain

import com.trevorwiebe.timesheet.mileage.domain.model.Location
import com.trevorwiebe.timesheet.mileage.domain.model.LocationType

/**
 * Normalizes a location field for comparison: lowercased with everything except
 * letters and digits removed. Dropping spaces entirely (rather than collapsing
 * them) means a place typed with or without a space — e.g. "Des Moines" and
 * "DesMoines" — still matches, while punctuation and casing differences are ignored.
 */
fun normalizeLocationField(value: String): String =
    value.lowercase().filter { it.isLetterOrDigit() }

/**
 * Finds an existing, non-deleted location of the given [type] whose normalized name,
 * city, and state all match. Used to automatically merge into an existing location
 * instead of creating a near-duplicate — for both receipt scans and manual entry.
 */
fun List<Location>.findMatchingLocation(
    type: LocationType,
    name: String,
    city: String,
    state: String
): Location? {
    val targetName = normalizeLocationField(name)
    val targetCity = normalizeLocationField(city)
    val targetState = normalizeLocationField(state)
    if (targetName.isEmpty()) return null
    return firstOrNull { location ->
        location.type == type &&
            !location.deleted &&
            normalizeLocationField(location.name) == targetName &&
            normalizeLocationField(location.city) == targetCity &&
            normalizeLocationField(location.state) == targetState
    }
}
